import { render, staticRenderFns } from "./TableRowServerItemComponent.vue?vue&type=template&id=011801c1"
import script from "./TableRowServerItemComponent.vue?vue&type=script&lang=ts"
export * from "./TableRowServerItemComponent.vue?vue&type=script&lang=ts"
import style0 from "./TableRowServerItemComponent.vue?vue&type=style&index=0&id=011801c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports